


















import { Component, Vue } from "vue-property-decorator";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import { namespace } from "vuex-class";
const space = namespace("SpaceStore");
@Component({
  name: "sidebar-header",
})
export default class SidebarHeaderComponent extends Vue {
  @space.State
  space!: SpaceInterface;
  get spaceUpdate(): SpaceInterface {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return space;
  }
  get sidebarFull(): boolean {
    return this.$store.getters["SidebarStore/getSidebarFull"];
  }
  spacesLength() {
    return this.$store.getters["SpaceStore/getSpacesAvailable"].length;
  }
  openChangeSpace() {
    this.$store.dispatch("SystemStore/setOpenChangeSpaceModalAction", true);
  }
}
